import { setFilledDate } from '@/imports-files/components/job-filters';
import { ACTION_OPTIONS, Check, Dots, moment, JobActionOptions, JobListing, setJobFilter, 
         Warning, REDIRECT, CommonAction, Clock, CloseIcon, CustomToastrAction} from '@/imports-files/pages/clients/jobs/job';

import { addParamsToUrl } from '../../admins/dashboard/clients/common';
import Tooltip from "react-simple-tooltip";
import { Verified } from '@/imports-files/pages/clients/jobs/candidate-profile-job';


export async function getJobListingData(params, setApiError)
{
  var body        =   params

  if(body.job_type == "Draft" )
  {
    body.all_jobs = false;
  }

  const result    =   await new JobListing().getJobListingData(body);
  setApiError(result.request);
  return result;
}

export async function handlePerRowsSorting( router, column, sortDirection, setJobList, setFiltersValue, setApiError)
{
    var param_list            =    router.query;
    param_list.col_name       =    column.sortField;
    param_list.order          =    sortDirection;
    addParamsToUrl(param_list, router);
    
    var result  =  await getJobListingData(param_list, setApiError);
    setApiError(result.request);
    setJobList(result.data);   
    setFiltersValue(param_list);

}

export async function handlePerRowsChange( router, per_page, setJobList, setFiltersValue, setApiError )
{
    var param_list            =    router.query;
    param_list.per_page       =    per_page;
    addParamsToUrl(param_list, router);
    var result                =    await getJobListingData(param_list, setApiError);
    setApiError(result.request);
    setJobList(result.data);   
    setFiltersValue(param_list);
}

export async function handlePageChange( router, page_number, setJobList, setFiltersValue, setApiError )
{
    var param_list        =    router.query;
    param_list.page       =    page_number;
    addParamsToUrl(param_list, router);
    var result            =    await getJobListingData(param_list, setApiError); 
    setApiError(result.request);
    setJobList(result.data);    
    setFiltersValue(param_list);
}

export async function changeJobTypeFilterData( event, setJobList, setFiltersValue, router, setApiError, setDatatableLoading)
{
    setDatatableLoading(true)
    var param_list         =    { job_type : event.target.value };
    setFiltersValue(param_list);
    document.querySelector('#jobSearch').value = ''
    addParamsToUrl(param_list, router);
    var result                    =   await getJobListingData(param_list, setApiError);
    setApiError(result.request);
    setJobList(result.data);
    setDatatableLoading(false);
}

export async function allJobFilterData(  event, setJobList, setFiltersValue, router, setApiError)
{
    var previous_job_filter          =    router.query;
    previous_job_filter.all_jobs     =    event.target.checked;
   localStorage.setItem('jobs_toggle', event.target.checked)
    setJobFilter(previous_job_filter);
    setFiltersValue(previous_job_filter);
    var result                      =    await getJobListingData(previous_job_filter, setApiError);
    setApiError(result.request);
    setJobList(result.data);
}

export async function changeSearchFilterData( event, setJobList, setFiltersValue, router, setApiError)
{
    var param_list            =    router.query;
    param_list.search_text    =    event.target.value ;
    param_list.search_text == '' ?  delete param_list.search_text : '';
    addParamsToUrl(param_list, router);
    var result                =    await getJobListingData(param_list, setApiError);
    setApiError(result.request);
    setJobList(result.data); 
    setFiltersValue(param_list);  
}

export async function handleFilterClick(event, job_filter, setJobFilter)
{
    if( event.target.classList.contains('JobFilterButton') || !event.target.closest('.JobFilter') )
    {
        job_filter == "Close" ? setJobFilter('Open') : setJobFilter('Close');
    }
}

export async function applyFilter( setFiltersValue, setModal, setJobList, startDate, endDate, location, router, setApiError, agency_user_emails, agency_user_initials)
{
    var commonAction   =  new CommonAction();
    var new_startDate  =  typeof startDate == 'string' ? commonAction.changeDateFormatToYearMonthDay(startDate) : startDate;
    var new_endDate    =  typeof endDate == 'string' ? commonAction.changeDateFormatToYearMonthDay(endDate) : endDate;

    if(startDate && endDate && moment(new_startDate).startOf('day').isAfter(new_endDate))
    {
        document.querySelector('.filterStartDate').innerHTML                = 'Date from should be lesser than date to';
        document.querySelector('.FilterCustomStartDate input').style.border = '1px solid red';
        return; // Return because date field has error
    }

    if((startDate && endDate && moment(new_startDate).isSameOrBefore(new_endDate)) || (startDate) || (endDate) || (location?.length > 0) || (agency_user_emails.length > 0))
    {
        var param_list = router.query;
        param_list.start_date                 =   typeof startDate == 'object' && startDate != null ? moment(startDate).format('DD/MM/YYYY') : startDate || '';
        param_list.end_date                   =   typeof endDate == 'object'   && endDate != null ? moment(endDate).format('DD/MM/YYYY') : endDate || '' ;
        param_list.location                   =   location  != '' ? location : '';
        param_list.agency_user_emails         =   agency_user_emails.length   > 0 ? agency_user_emails : '';
        param_list.agency_user_names          =   agency_user_initials.length > 0 ? agency_user_initials.map((x) => x.name) : '';
        param_list.agency_user_photo_urls     =   agency_user_initials.length > 0 ? agency_user_initials.map((x) => x.photo_url) : '';
        param_list.agency_user_name_initials  =   agency_user_initials.length > 0 ? agency_user_initials.map((x) => x.name_initials) : '';
        addParamsToUrl(param_list, router);
        var result                               =   await getJobListingData(param_list, setApiError);
        setApiError(result.request);
        setJobList(result.data);  
        setFiltersValue(param_list);
        setModal('Close');
    }
    else
    {
        const customToastrAction  =   new CustomToastrAction();
        customToastrAction.setNormalToastr("Select some filters", 'warning');
    }
}

export function openJobOptions(event)
{
    event.stopPropagation();
    var dots_element = event.currentTarget.querySelector('.Dots');
    var element = event.currentTarget.querySelector('.JobActionOptions')

    if(dots_element.classList.contains('Close'))
    {
        closeAllJobsOptions();
        element.classList.remove('Close');
        element.classList.add('Open');

        dots_element.classList.remove('Close');
        dots_element.classList.add('Open');
    }
    else
    {
        closeAllJobsOptions();
        element.classList.remove('Open');
        element.classList.add('Close');

        dots_element.classList.remove('Open');
        dots_element.classList.add('Close');
    }
}

export function closeAllJobsOptions()
{
    var element = document.querySelector('.JobActionOptions.Open');
    var dots_element = document.querySelector('.Dots.Open');
    if(element)
    {
        element.classList.remove('Open');
        element.classList.add('Close');
        dots_element.classList.remove('Open');
        dots_element.classList.add('Close');
    }
}


export function getColumnsName( userRole, setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, setPendingDashboardList)
{
    var jobType = router.query.job_type;
    if(userRole == 'client_admin' || userRole == 'account_owner' || userRole == 'Administrator' || userRole == 'SubAdministrator')
    {
        return adminDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, setPendingDashboardList);
    }
    else
    {
        return clientDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session, setInfoModal);
    }
}

export function adminDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, setPendingDashboardList)
{
    switch(jobType)
    {
        case 'Active'     :  return (adminActiveColumns(setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, setPendingDashboardList));
        case 'Draft'      :  return (adminDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session));
        case 'Archived'   :  return (adminArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session));
        default           :   '';
    }
}

export function clientDatTableColumns(jobType, setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session)
{

    switch(jobType)
    {
        case 'Active'     :  return (clientUserActiveColumns(setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session));
        case 'Draft'      :  return (clientUserDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session));
        case 'Archived'   :  return (clientUserArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session));
        default           :   '';
    }
}

export function adminActiveColumns(setPageName, setJobList, setjobEditModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, router, setApiError, setJobCloseModal, session, setInfoModal, setPendingDashboardList)
{ 
    let activeColumns = [
                            {
                                name: 'Job',
                                selector: row => {
                                                    var link  = ''
                                                    if(row.job_type=='Active' || row.job_type=='Archived')
                                                    { 
                                                        link = REDIRECT.client.kanban_board.replace('$job_id', row.id);
                                                    }
                                                    else
                                                    {
                                                        link = REDIRECT.client.jobs.edit.replace('$job_id', row.id);
                                                    }
                                                    return( linkWithTitle( row.title, link, router));
                                                 },
                                sortable: true, 
                                sortField: 'title'
                            },
                            {
                                name: 'Applicants',
                                selector: row => row.applicants||0,
                                sortable: true, 
                                sortField: 'applicants',
                                className: 'Datatable_Applicants'
                            },
                            {
                                name: 'Agency',
                                selector: row => row.agency,
                            },
                            {
                                name: 'Created',
                                selector: row => row.created_at,
                                sortable: true, 
                                sortField: 'created_at'
                            },
                            {
                                name: 'Last Updated',
                                selector: row => row.updated_at,
                                sortable: true, 
                                sortField: 'updated_at'
                            },
                            {
                                name: 'Job Owner(s)',
                                selector: row => { 
                                                    return(row.job_owners.map( (element, index) =>  <div key={`job_owner_initials_${index}`} className="JobSection">
                                                                                                        { element?.photo_url ? <img src={element?.photo_url} className="JobImage"/>
                                                                                                                             :  <div className="JobInitial">
                                                                                                                                    <span>{element.initials ? element.initials : "?"}</span>
                                                                                                                                </div>}
                                                                                                      <div className="JobName">  {element.name} </div> 
                                                                                                    </div>))
                                              
                                                },
                                sortable: true, 
                                sortField: 'job_creator'
                            },
                            {
                                name: 'Status',
                                selector: row => {
                                                    return(setJobApplicationStatus(row, setInfoModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, setPendingDashboardList))
                                                },
                                sortable: false, 
                                sortField: ''
                            },
                        
                            {
                                name: '',
                                selector: row => { return (
                                                                <div className="DotsOptions" onClick={(event) => openJobOptions(event)}> 
                                                                    <Dots className="Dots Close" />
                                                                    <JobActionOptions options             =   {ACTION_OPTIONS} 
                                                                                      job_id              =   {row.id} 
                                                                                      setPageName         =   {setPageName} 
                                                                                      slug                =   {row.slug} 
                                                                                      setJobList          =   {setJobList}
                                                                                      setjobEditModal     =   {setjobEditModal} 
                                                                                      rowData             =   {row}
                                                                                      closeAllJobsOptions =   {closeAllJobsOptions} 
                                                                                      setApiError         =   {setApiError}
                                                                                      setJobCloseModal    =   {setJobCloseModal}
                                                                                      title               =   {row.title}
                                                                                      session             =    {session}
                                                                                      />
                                                                </div>
                                                           )}
                            }
                       ]

    if(router.query.attention_token){
        activeColumns.splice(5, 0, {name: 'Comment', selector: row => row.attention_comment || '-'});
    }
    return activeColumns;
}

export function adminDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session)
{               return ([
                            {
                                name: 'Job',
                                selector: row => {
                                                    var link  = ACTION_OPTIONS.edit_job.link.replace('$job_id', row.id);
                                                    return( linkWithTitle( row.title, link, router));
                                                },
                                sortable: true, 
                                sortField: 'title'
                            },
                            {
                                name: 'Agency',
                                selector: row => row.agency,
                            },
                            {
                                name: 'Created',
                                selector: row => row.created_at,
                                sortable: true, 
                                sortField: 'created_at'
                            },
                            {
                                name: 'Last Updated',
                                selector: row => row.updated_at,
                                sortable: true, 
                                sortField: 'updated_at'
                            },
                            {
                                name: 'Job Owner(s)',
                                selector: row => { 
                                                    return(row.job_owners.map( (element, index) =>  <div key={`job_owner_initials_${index}`} className="JobSection">
                                                                                                            { element?.photo_url ? <img src={element?.photo_url} className="JobImage"/>
                                                                                                                                 : <div className="JobInitial">
                                                                                                                                    <span>{element.initials ? element.initials : "?"}</span>
                                                                                                                                   </div>}
                                                                                                        <div className="JobName">  {element.name} </div>
                                                                                                    </div>))
                                                },
                                sortable: true, 
                                sortField: 'job_creator'
                            },
                            {
                                name: '',
                                selector: row =>  <div className="DotsOptions" onClick={(event) => openJobOptions(event)}> 
                                                        <Dots className="Dots Close"/>
                                                        <JobActionOptions options           =   {ACTION_OPTIONS} 
                                                                        job_id              =   {row.id} 
                                                                        setPageName         =   {setPageName} 
                                                                        slug                =   {row.slug} 
                                                                        setJobList          =   {setJobList}
                                                                        publishable         =   {row.publishable} 
                                                                        setjobEditModal     =   {setjobEditModal}
                                                                        closeAllJobsOptions =   {closeAllJobsOptions}
                                                                        setApiError         =   {setApiError}
                                                                        session             =    {session}/>
                                                </div>
                            }
                        ])
}

export function adminArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session)
{  return ([
                            {
                                name: 'Job',
                                selector: row => {
                                                    var link = REDIRECT.client.kanban_board.replace('$job_id', row.id);
                                                    return( linkWithTitle( row.title, link, router));
                                                },
                                sortable: true, 
                                sortField: 'title'
                            },
                            {
                                name: 'Applicants',
                                selector: row => row.applicants||0,
                                sortable: true, 
                                sortField: 'applicants'
                            },
                            {
                                name: 'Agency',
                                selector: row => row.agency,
                            },
                            {
                                name: 'Hired',
                                selector: row => row.hired || 0,
                                sortable: true, 
                                sortField: ''
                            },
                            {
                                name: 'Created',
                                selector: row => row.created_at,
                                sortable: true, 
                                sortField: 'created_at'
                            },
                            {
                                name: 'Archived ',
                                selector: row => row.archived_at,
                                sortable: true,
                                sortField: 'archived_at'
                            },
                            {
                                name: 'Job Owner(s)',
                                selector: row => { 
                                                return(row.job_owners.map( (element, index) =>  <div key={`job_owner_initials_${index}`} className="JobSection">
                                                                                                  
                                                                                                   { element?.photo_url ? <img src={element?.photo_url} className="JobImage"/>
                                                                                                                        : <div className="JobInitial">
                                                                                                                             <span>{element.initials ? element.initials : "?"}</span>
                                                                                                                          </div>}
                                                                                                   <div className="JobName">  {element.name} </div>
                                                                                                </div>))
                                                },
                                sortable: true, 
                                sortField: 'job_creator'
                            },
                            {
                                name: '',
                                selector: row =>  <>{ session.role != 'SubAdministrator' && <div className="DotsOptions" onClick={(event) => openJobOptions(event)}>
                                                        <Dots className="Dots Close" />
                                                        <JobActionOptions options      =   {ACTION_OPTIONS} 
                                                                        job_id       =   {row.id} 
                                                                        setPageName  =   {setPageName} 
                                                                        slug         =   {row.slug} 
                                                                        setJobList   =   {setJobList} 
                                                                        setjobEditModal = {setjobEditModal}
                                                                        closeAllJobsOptions =   {closeAllJobsOptions}
                                                                        setApiError         =   {setApiError}
                                                                        session             =    {session}
                                                         />
                                                </div>}</>
                            }
                        ])
}

export function clientUserActiveColumns(setPageName, setJobList, setjobEditModal, router, setApiError, setJobCloseModal, session)
{ 
    let activeColumns = [
                            {
                                name: 'Job',
                                selector: row => {
                                                    var link = '';
                                                    // var link = REDIRECT.client.kanban_board.replace('$job_id', row.id);
                                                    if(row.job_type=='Active' || row.job_type=='Archived')
                                                    { 
                                                        link = REDIRECT.client.kanban_board.replace('$job_id', row.id);
                                                    }
                                                    else
                                                    {
                                                        link = REDIRECT.client.jobs.edit.replace('$job_id', row.id);
                                                    }
                                                    return( linkWithTitle( row.title, link, router));
                                                 },
                                sortable: true, 
                                sortField: 'title'
                            },
                            {
                                name: 'Applied',
                                selector: row => row.applied,
                                sortable: true, 
                                sortField: 'applied'
                            },
                            {
                                name: 'Screening',
                                selector: row => row.screening,
                                sortable: true, 
                                sortField: 'screening'
                            },
                            {
                                name: 'Interview',
                                selector: row => row.interview,
                                sortable: true,
                                sortField: 'interview'
                            },
                            {
                                name: 'Offered',
                                selector: row => row.offered,
                                sortable: true, 
                                sortField: 'offered'
                            },
                            {
                                name: 'Hired',
                                selector: row => row.hired,
                                sortable: true, 
                                sortField: 'hired'
                            },
                            {
                                name: 'Agency',
                                selector: row => row.agency,
                            },
                            {
                                name: 'Date',
                                selector: row => row.updated_at,
                                sortable: true, 
                                sortField: 'updated_at'
                            },
                            {
                                name: 'Location',
                                selector: row => { 
                                                    return row.location
                                                 },
                                sortable: true, 
                                sortField: 'country'
                            },
                            {
                                name: '',
                                selector: row => {
                                                    return(
                                                    <div className="DotsOptions" onClick={(event) => openJobOptions(event)}> 
                                                        <Dots className="Dots Close"/>
                                                        <JobActionOptions options             =   {ACTION_OPTIONS} 
                                                                          job_id              =   {row.id} 
                                                                          setPageName         =   {setPageName} 
                                                                          slug                =   {row.slug} 
                                                                          setJobList          =   {setJobList} 
                                                                          editable            =   {row.editable}
                                                                          setjobEditModal     =   {setjobEditModal}
                                                                          closeAllJobsOptions =   {closeAllJobsOptions}
                                                                          setApiError         =   {setApiError}
                                                                          setJobCloseModal    =   {setJobCloseModal}
                                                                          title               =   {row.title}
                                                                          session             =    {session}
                                                                          />
                                                    </div>)
                                }
                            }
            ];

    if(router.query.attention_token){
        //After Date
        activeColumns.splice(7, 0, {name: 'Comment', selector: row => row.attention_comment || '-'});
    }
    return activeColumns;
}

export function clientUserDraftColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session)
{               return ([
                                {
                                    name: 'Job',
                                    selector: row => {
                                                        var link  = ACTION_OPTIONS.edit_job.link.replace('$job_id', row.id);
                                                        return( linkWithTitle( row.title, link, router));
                                                     },
                                    sortable: true, 
                                    sortField: 'title'
                                },
                                {
                                    name: 'Agency',
                                    selector: row => row.agency,
                                },
                                {
                                    name: 'Created',
                                    selector: row => row.created_at,
                                    sortable: true, 
                                    sortField: 'created_at'
                                },
                                {
                                    name: 'Last Updated',
                                    selector: row => row.updated_at,
                                    sortable: true, 
                                    sortField: 'updated_at'
                                },
                                {
                                    name: 'Job Owner(s)',
                                    selector: row =>  { 
                                                        return(row.job_owners.map( (element,index) =>   <div key={`job_owner_initials_${index}`} className="JobSection">
                                                                                                            {element?.photo_url ? <img src={element?.photo_url} className="JobImage"/>
                                                                                                                                : <div className="JobInitial">
                                                                                                                                    <span>{element.initials ? element.initials : "?"}</span>
                                                                                                                                  </div>}
                                                                                                            <div className="JobName">  {element.name} </div>
                                                                                                         </div>))
                                                        },
                                    sortable: true, 
                                    sortField: 'job_creator'
                                },
                                {
                                    name: '',
                                    selector: row =>  {
                                                        return(  
                                                                <div className="DotsOptions" onClick={(event) => openJobOptions(event)}> 
                                                                    <Dots className="Dots Close" />
                                                                    <JobActionOptions options           =   {ACTION_OPTIONS} 
                                                                                      setPageName         =   {setPageName} 
                                                                                      job_id              =   {row.id} 
                                                                                      slug                =   {row.slug} 
                                                                                      setJobList          =   {setJobList}
                                                                                      publishable         =   {row.publishable} 
                                                                                      editable            =   {row.editable}
                                                                                      setjobEditModal     =   {setjobEditModal}
                                                                                      closeAllJobsOptions =   {closeAllJobsOptions}
                                                                                      setApiError         =   {setApiError}
                                                                                      session             =    {session}
                                                                                    />
                                                                </div>)
                                                       }
                                }
                        ])
}

export function clientUserArcheivedColumns(setPageName, setJobList, setjobEditModal, router, setApiError, session)
{  return ([
                            {
                                name: 'Job',
                                selector: row => {
                                                    var link = REDIRECT.client.kanban_board.replace('$job_id', row.id);
                                                    return( linkWithTitle( row.title, link, router));
                                                },
                                sortable: true, 
                                sortField: 'title'
                            },
                            {
                                name: 'Applicants',
                                selector: row => row.applicants,
                                sortable: true, 
                                sortField: 'applicants'
                            },
                            {
                                name: 'Agency',
                                selector: row => row.agency,
                            },
                            {
                                name: 'Hired',
                                selector: row => row.hired || 0,
                                sortable: true, 
                                sortField: ''
                            },
                            {
                                name: 'Created',
                                selector: row => row.created_at,
                                sortable: true, 
                                sortField: 'created_at'
                            },
                            {
                                name: 'Archived',
                                selector: row => row.archived_at,
                                sortable: true,
                                sortField: 'archived_at'
                            },
                            {
                                name: 'Job Owner(s)',
                                selector: row => { 
                                                    return(row.job_owners.map( (element, index) =>   <div key={`job_owner_initials_${index}`} className="JobSection">
                                                                                                        {element?.photo_url ? <img src={element?.photo_url} className="JobImage"/> 
                                                                                                                            : <div className="JobInitial">
                                                                                                                                <span>{element.initials ? element.initials : "?"}</span>
                                                                                                                              </div>}
                                                                                                        <div className="JobName">  {element.name} </div>
                                                                                                     </div>))
                                                },
                                sortable: true, 
                                sortField: 'job_creator'
                            },
                            {
                                name: '',
                                selector: row =>  {     
                                                        return(
                                                                  <>{ session.role != 'SubAdministrator' && <div className="DotsOptions" onClick={(event) => openJobOptions(event)}>
                                                                        <Dots className="Dots Close"/>
                                                                        {   <JobActionOptions options      =   {ACTION_OPTIONS} 
                                                                                                              job_id       =   {row.id} 
                                                                                                              setPageName  =   {setPageName} 
                                                                                                              slug         =   {row.slug} 
                                                                                                              setJobList   =   {setJobList} 
                                                                                                              setjobEditModal ={setjobEditModal}
                                                                                                              closeAllJobsOptions =   {closeAllJobsOptions}
                                                                                                              setApiError         =   {setApiError}
                                                                                                              session             =    {session}
                                                                            />
                                                                        }
                                                                    </div>}</>
                                                                )}
                            }
                        ])
}

export function closeEditJobModal(setjobEditModal)
{
    setjobEditModal(['Close','']);
}

export function goToEditJob(job_edit_modal_link, router)
{
    router.push(job_edit_modal_link);
}

export async function warningPopUp(job_id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList)
{   
    if(row.all_discard){
      const customToastrAction  =   new CustomToastrAction();
      customToastrAction.setNormalToastr(row.message, 'warning');
    }
    else{
      var result = await new JobListing().failedJobBoardList(job_id);
      setFailedDashboardList(result.data.not_published)
      setPublishedDashboardList(result.data.published)
      setPendingDashboardList(result.data.pending)
      setStatusJobId(job_id);
      setJobStatusModal('Open');
    } 
}

export async function retryJobOnJobBoard(job_id, setJobStatusModal, setDisableButton, setShowLoader, integration_id)
{  
    var all_checkbox        =   document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
    var integration_ids     =   [integration_id];
    const customToastrAction  =   new CustomToastrAction();
    // for(var element of all_checkbox)
    // {
    //     if(element.checked)
    //     {
    //         integration_ids.push(element.value);
    //     }
    // }
    setShowLoader(true);
    var result = await new JobListing().retryJobsOnJobBoardService(integration_ids, job_id);
    setShowLoader(false);
    setDisableButton(true);
    setJobStatusModal('Close');
    if(result.response?.data?.error){
        customToastrAction.setNormalToastr(result.response.data.error, 'error');
    }
    else if(result?.data?.success){
        customToastrAction.setNormalToastr(result.data.success, 'success');
    }
}

export async function dismissJobOnJobBoard(job_id, setJobStatusModal, setDisableButton, setShowLoader, integration_id, failedCount)
{  
    var all_checkbox        =   document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
    var integration_ids     =   [integration_id];

    // for(var element of all_checkbox)
    // {
    //     if(element.checked)
    //     {
    //         integration_ids.push(element.value);
    //     }
    // }
    let discard_all = failedCount == 1 ? true : false
    setShowLoader(true);
    var result = await new JobListing().dismissJobsOnJobBoardService(integration_ids, job_id, discard_all);
    setShowLoader(false);
    setDisableButton(true);
    setJobStatusModal('Close');
}

export function isJobFilterApplied(router)
{
    var previous_job_filter  =  router.query
    return previous_job_filter?.start_date || previous_job_filter?.end_date || previous_job_filter?.location || previous_job_filter.agency_user_emails;
}

function linkWithTitle(title_name, redirect_link, router)
{
    var previous_job_filter   =    router.query;

    switch(previous_job_filter?.job_type)
    {
        case 'Active':  return( <div className = {'EditableTitle'} onClick={ ()=>{goToKanbanBoard(router, redirect_link)}}>
                                    {title_name}
                                </div>);
        case 'Draft':   return( <div className = {'EditableTitle'}
                                     onClick   = { ()=>{ goToEditJob(redirect_link, router)} }>
                                     {title_name}
                                </div>);
        case 'Archived': return( <div className = {'EditableTitle'} onClick={ ()=>{goToKanbanBoard(router, redirect_link)}}>
                                    {title_name}
                                </div>);
        default : '';
    }

}

function goToKanbanBoard(router, redirect_link)
{
    router.push(redirect_link);
}

export function setDataTableClass( job_type, role)
{
    switch(job_type)
    {
        case 'Active':
                            if(role=='client_admin' ||  role=='account_owner')
                            {
                                return 'ClientAdminActiveTable'
                            }
                            else if(role=='client_user')
                            {
                                return 'ClientUserActiveTable'
                            }
                            else
                            {
                                return 'ClientReviewerActiveTable'
                            }
        case 'Draft':
                            if(role=='client_admin' ||  role=='account_owner')
                            {
                                return 'ClientAdminDraftTable'
                            }
                            else if(role=='client_user')
                            {
                                return 'ClientUserDraftTable'
                            }
                            else
                            {
                                return 'ClientReviewerDraftTable'
                            }
        case 'Archived':
                            if(role=='client_admin' ||  role=='account_owner')
                            {
                                return 'ClientAdminArchivedTable'
                            }
                            else if(role=='client_user')
                            {
                                return 'ClientUserArchivedTable'
                            }
                            else
                            {
                                return 'ClientReviewerArchivedTable'
                            }
        default: '';
    }
}


export function onSelectJob(event, setDisableButton, setHeaderChecked)
{
    var all_checkbox        =   document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');
    var no_job_selected     =   true;
    var discard_jobs_button =   document.querySelector('.DiscardJobs');
    var retry_jobs_button   =   document.querySelector('.RetryJobs');
    var checked_count       =   0;
    var header_checkbox     =   document.querySelector('.HeadingCheckboxSection input');
    for(var element of all_checkbox)
    {
        if(element.checked)
        {
            checked_count                 =  checked_count + 1;
            discard_jobs_button.disabled  =  false;
            retry_jobs_button.disabled    =  false;
            no_job_selected               =  false;
            setDisableButton(false);
        }
    }

    checked_count == all_checkbox.length ?  setHeaderChecked(true) : setHeaderChecked(false);

    if(no_job_selected)
    {
        discard_jobs_button.disabled = true;
        retry_jobs_button.disabled   = true;
        setDisableButton(true);
    }   
}

export function selectAllBoard(event, setDisableButton, setHeaderChecked)
{
    var all_checkbox        =   document.querySelectorAll('.JobStatusErrorSection input[type="checkbox"]');

    if(event.currentTarget.checked)
    {
        for(var element of all_checkbox)
        {
            if(!element.checked)
            {
                element.click();
            }
            // element.checked = true;
        }
    }
    else
    {
        for(var element of all_checkbox)
        {
            if(element.checked)
            {
                element.click();
            }
            // element.checked = true;
        }
    }
    
    setHeaderChecked(event.target.checked);
    setDisableButton(!event.target.checked);

}

export function emailVerifiedOrNot(email, email_verified)
{
    if(email && email.length > 0 )
    {
         return email_verified ? <> <Tooltip className='SimpleTooltip' content="Verified" background= {'#00325A'} radius={20} padding = {8} placement	= "top" fontSize= "12px">   <p className={`tooltipwidth`}><Verified /></p></Tooltip> {" "}</>
                               : <></>;
        //                        <> <Tooltip className='SimpleTooltip' content="Not Verified" background= {'#00325A'} radius={20} padding = {8} placement	= "top" fontSize= "12px">
        // <p className={`tooltipwidth`}><Warning /></p> {" "}</Tooltip></>
    }
}


export function changeDelay(timer, setTimer, event, setJobList, setFiltersValue, router, setApiError) 
{
  if (timer) 
  {
    clearTimeout(timer);
    setTimer(null);
  }
  setTimer(
    setTimeout(() => {
                        changeSearchFilterData( event, setJobList, setFiltersValue, router, setApiError )
                     }, 500)
  );
}


export function goToApprovalRequest(router)
{
    let link = REDIRECT.client.jobs.approvals_listing
    router.push({pathname: link, query:{tab: "jobs"}})
}


export function setJobApplicationStatus(row, setInfoModal, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, setPendingDashboardList)
{
    switch(row.job_status)
    {
        case 'Published': return ( <div onClick = { () => { warningPopUp(row.id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList) } }> <Tooltip className='SimpleTooltip' content="Published" background= {'#00325A'} radius={20} padding = {8} placement	= "top" fontSize= "12px"> <Check/> </Tooltip></div>);
        case 'Failed To Publish': return ( <div className="Warning" onClick = { () => { warningPopUp(row.id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList) } }>
                   <Tooltip className='SimpleTooltip' content="Failed to publish" background= {'#00325A'} radius={20} padding = {8} placement	= "top" fontSize= "12px"> <Warning/> </Tooltip>
                </div> );
        case 'Queued': return ( <div onClick = { () => { warningPopUp(row.id, setJobStatusModal, setFailedDashboardList, setPublishedDashboardList, setStatusJobId, row, setPendingDashboardList) } }> <Tooltip className='SimpleTooltip' content="Queued" background= {'#00325A'} radius={20} padding = {8} placement   = "top" fontSize= "12px"> <Clock/> </Tooltip></div>);
        case 'Pending': return  ( <div onClick={()=>{openInfoModal(row, setInfoModal)}}> <Tooltip className='SimpleTooltip' content={`Approvers ${row.pending_approval_text}`} background= {'#00325A'} radius={20} padding = {8} placement = "top" fontSize= "12px"> <Clock/> </Tooltip></div>)
        case 'Rejected': return ( <div className='Rejected' onClick={()=>{openInfoModal(row, setInfoModal)}}> <Tooltip className='SimpleTooltip' content="Rejected" background= {'#00325A'} radius={20} padding = {8} placement = "top" fontSize= "12px"> <CloseIcon/> </Tooltip></div>)
        case 'Approved': return ( <div> <Tooltip className='SimpleTooltip' content="Approved" background= {'#00325A'} radius={20} padding = {8} placement = "top" fontSize= "12px"> <Check/> </Tooltip></div>)
        default:'';
    }
}

export function openInfoModal(row, setInfoModal)
{
    setInfoModal({state: true, heading: row.job_status =='Rejected' ? 'Rejection Reasons' : 'Approvers List', message: row.job_status =='Rejected' ? row.reject_reason : row.approvers, job_status:row.job_status})
}
